import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, HardHat, Zap, Weight, Gauge, LandPlot, Shield, Wrench, Hammer } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import BrandSlider from '../components/BrandSlider';
import { products } from '../utils/products';
import { useApp } from '../context/AppContext';
import { useState, useEffect } from "react";
import imagensliderhome1 from '../assets/images/HomePage/SliderHome1.webp';
import imagensliderhome2 from '../assets/images/HomePage/SliderHome2.webp';
import imagensliderhome3 from '../assets/images/HomePage/SliderHome3.webp';
import imagenwidget1 from '../assets/images/HomePage/imagenwidget1.webp';
import imagenwidget2 from '../assets/images/HomePage/imagenwidget2.webp';
import imagenwidget3 from '../assets/images/HomePage/imagenwidget3.webp';
import imagenwidget4 from '../assets/images/HomePage/imagenwidget4.webp';
import imagenwidget5 from '../assets/images/HomePage/imagenwidget5.webp';
import imagenwidget6 from '../assets/images/HomePage/imagenwidget6.webp';
import imagenwidget7 from '../assets/images/HomePage/imagenwidget7.webp';
import imagenwidget8 from '../assets/images/HomePage/imagenwidget8.webp';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const HomePage = ({ setCurrentPage }) => {
  const { t } = useApp();

  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    imagensliderhome1,
    imagensliderhome2,
    imagensliderhome3
  ];

  // Autoplay slider home de cada 10 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const categories = [
    {
      key: 'ppe',
      title: t.categories.ppe,
      icon: HardHat,
      description: 'Cascos, Guantes de Nitrilo, Mono Gafas, Protectores Auditivos, Guantes de Vaqueta, etc.',
      image: imagenwidget1
    },
    {
      key: 'tct',
      title: t.categories.tct,
      icon: Zap,
      description: 'Pértigas, Guantes, Mangas, Mantas, Tapetes, Botas, cobertores dieléctricos, Jumpers, By pass, etc.',
      image: imagenwidget2
    },
    {
      key: 'enm',
      title: t.categories.enm,
      icon: Weight,
      description: 'Antenallas, Garruchas, Cadenas, Poleas, Ponchadoras, etc.',
      image: imagenwidget3
    },
    {
      key: 'mydTools',
      title: t.categories.mydTools,
      icon: Gauge,
      description: 'Detectores de Tensión para redes y personales, multímetros, pinzas voltiamperimétricas, Meggers, Analizadores de Red, Comparadores de Fase, etc.',
      image: imagenwidget4
    },
    {
      key: 'ept',
      title: t.categories.ept,
      icon: LandPlot,
      description: 'Equipo de puesta a tierra temporal de Baja, Media y Alta Tensión.',
      image: imagenwidget5
    },
    {
      key: 'heightWork',
      title: t.categories.heightWork,
      icon: Shield,
      description: 'Arnés dieléctrico, Líneas de vida, Eslingas, Mosquetones, Ascendedores, Pretales, Escaleras Dieléctricas, etc.',
      image: imagenwidget6
    },
    {
      key: 'isolatedTools',
      title: t.categories.isolatedTools,
      icon: Wrench,
      description: 'Alicates, Destornilladores, Llaves Hexagonales, Herramientas Aislada hasta 1000 VAC, etc.',
      image: imagenwidget7
    },
    {
      key: 'manualandmotorTools',
      title: t.categories.manualandmotorTools,
      icon: Hammer,
      description: 'Alicates, Destornilladores, Llaves fijas, Taladros, Rotomartillos, etc.',
      image: imagenwidget8
    }
  ];

  const featuredProducts = [
    products.tct.find(p => p.id === 73),
    products.tct.find(p => p.id === 27),
    products.mydTools.find(p => p.id === 106),
    products.mydTools.find(p => p.id === 101)
  ].filter(Boolean);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section*/}
      <section className="relative pb-10 bg-white">
        {/* Contenido Principal */}
        <div className="w-screen h-[300px] md:h-[450px] lg:h-[600px]">
          
          {/* SLIDER HOME */}
          <div className="relative w-full h-full overflow-hidden bg-black">
          
            {/* Imágenes */}
            {slides.map((img, index) => (
              <div
                key={index}
                onClick={() => {
                  if (index === 2 && index === currentSlide) {
                    window.open("https://otonito69.github.io/CatalogueInverdronJGW/", "_blank");
                  }
                }}
                className={`absolute w-full h-full transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0"
                  } ${index === 2 ? "cursor-pointer" : ""}`}
                style={{
                  backgroundImage: `url(${img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center top",
                  backgroundRepeat: "no-repeat"
                }}
              />
            ))}

            {/* Indicadores */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {slides.map((_, index) => (
                <div
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full cursor-pointer ${index === currentSlide
                    ? "bg-gradient-to-r from-blue-500 to-blue-800"
                    : "bg-white/40"
                    }`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Elementos decorativos de fondo */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-blue-100/30 to-yellow-100/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-yellow-100/20 to-blue-100/30 rounded-full blur-3xl"></div>
        </div>
      </section>

      {/* Barra de Marcas Animada */}
      <BrandSlider />

      {/* Sección de Categorías con Animaciones Mejoradas */}
      <section className="py-10 bg-gradient-to-b from-white/50 via-black/20 to-black/20">
        <div className="container mx-auto">
          <motion.h2
            className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-700 to-blue-600 bg-clip-text text-transparent"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            Nuestras Categorías
          </motion.h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, index) => (
              <motion.div
                key={category.key}
                className={`relative p-6 rounded-2xl text-white cursor-pointer transition-all shadow-xl shadow-gray-700 overflow-hidden group`}
                style={{ 
                  backgroundImage: `url(${category.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}  
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0 + index * 0.1 }}
                onClick={() => setCurrentPage(category.key)}
                whileHover={{ 
                  scale: 1.08,
                  rotateY: 5,
                  rotateX: 5,
                  z: 50
                }}
              >
                {/* Overlay oscuro */}
                <div className="absolute inset-0 bg-gradient-to-r from-black via-transparent to-white/40 group-hover:bg-black/50 transition-all duration-500 z-10"></div>

                {/* Efecto de brillo en hover */}
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/ -translate-x-full group-hover:translate-x-full transition-transform duration-700"
                  initial={{ x: '-100%' }}
                />
                
                {/* Contenido de la tarjeta */}
                <motion.div 
                  className="relative z-10"
                  whileHover={{ z: 20 }}
                >
                  <motion.div 
                    className="mb-4"
                    whileHover={{ 
                      scale: 1.2,
                      rotate: [0, -10, 10, 0],
                      transition: { duration: 0.5 }
                    }}
                  >
                    <category.icon className="w-12 h-12" />
                  </motion.div>
                  <motion.h3 
                    className="text-xl font-bold mb-2"
                    whileHover={{ scale: 1.05 }}
                  >
                    {category.title}
                  </motion.h3>
                  <motion.p 
                    className="text-white/90 text-sm mb-4"
                    whileHover={{ scale: 1.02 }}
                  >
                    {category.description}
                  </motion.p>
                  <motion.div 
                    className="flex items-center text-sm font-semibold"
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    Ver productos 
                    <motion.div
                      whileHover={{ x: 5 }}
                      transition={{ type: "spring", stiffness: 400 }}
                    >
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </motion.div>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Productos Destacados */}
      <section className="relative pt-5 pb-10 bg-gradient-to-b from-black/20 via-black/95 to-black overflow-hidden">
        
        <div className="container mx-auto z-10">
          <motion.h2
            className="text-3xl font-bold text-center mb-12 bg-white bg-clip-text text-blue-700 gap-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <span className="text-yellow-500">★</span>
            Productos Destacados
          </motion.h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredProducts.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
          
        </div>
      </section>
    </div>
  );
};

export default HomePage;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.